export default __webpack_public_path__ + "static/media/VEB_accident.eca18999.png";